import { Classroom } from 'lingo2-models';

export enum ClassroomCardActionsEnum {
  schedule_meeting,
  invite,
  edit,
  pin,
  unpin,
  leave,
  archive,
  restore,
  break_contract,
}

interface IClassroomCardOptionState {
  is_pined: boolean;
}

export interface IClassroomCardOption {
  id: ClassroomCardActionsEnum;
  label: string;
  enabled?: boolean | ((classroom: Classroom, state: IClassroomCardOptionState) => boolean);
}
